<template>
    <div class="nk-main ">
      <div class="nk-wrap nk-wrap-nosidebar">
        <div class="nk-content ">
          <div class="nk-split nk-split-page nk-split-lg">
            <div class="nk-split-content nk-block-area nk-block-area-column nk-auth-container bg-white">
              <div class="absolute-top-right d-lg-none p-3 p-sm-5">
                <a href="#" class="toggle btn-white btn btn-icon btn-light" data-target="athPromo">
                  <em class="icon ni ni-info"></em>
                </a>
              </div>
              <div class="nk-block nk-block-middle nk-auth-body" v-if="page_no==1">
                <div class="brand-logo pb-5">
                  <a href="#" class="logo-link">
                    <img class="logo-light logo-img logo-img-lg" :src="base_url+'images/logo-dark.png'" :srcset="base_url+'images/logo-dark.png'" alt="logo">
                    <img class="logo-dark logo-img logo-img-lg" :src="base_url+'images/logo-dark.png'" :srcset="base_url+'images/logo-dark.png'" alt="logo-dark">
                  </a>
                </div>
                <div class="nk-block-head">
                  <div class="nk-block-head-content">
                    <h5 class="nk-block-title">Sign-In</h5>
                  
                  </div>
                </div>
                <form @submit.prevent="handleSubmit" class="form-validate is-alter" autocomplete="off" novalidate="novalidate">
                  <div class="form-group">
                    <div class="form-label-group">
                      <label class="form-label" for="email-address">Email Address</label>
                    </div>
                    <div class="form-control-wrap">
                      <input autocomplete="off" type="email" v-model="email" class="form-control form-control-lg" required="" id="email-address" placeholder="Enter your email address">
                    </div>
                  </div>
                  <div class="form-group">
                    <div class="form-label-group">
                      <label class="form-label" for="password">Password</label>
                      <a class="link link-primary link-sm" tabindex="-1" href="javascript:void(0)" @click="set_page(3)"><span style="color:#1ee0ac;">Forgot Password?</span></a>
                    </div>
                    <div class="form-control-wrap">
                      <a tabindex="-1" href="#" class="form-icon form-icon-right Password-switch lg" data-target="password">
                        <em v-if="viewPass==1" @click="set_pass(0)" class="Password-icon icon-show icon ni ni-eye"></em>
                        <em v-if="viewPass==0" @click="set_pass(1)" class="Password-icon icon-hide icon ni ni-eye-off"></em>
                      </a>
                      <input autocomplete="new-password" v-model="password" :type="input_type" class="form-control form-control-lg" required="" id="password" placeholder="Enter your Password">
                    </div>
                  </div>
                  <div :class="'alert alert-' + msgType + ' mb-xl-0'" role="alert"
                                            v-if="msgTxt && msgTxt.length > 0">
                                            {{ msgTxt }}
                                        </div>
                                        <br>
                  <div class="form-group">
                    <button type="submit" class="btn btn-lg btn-success btn-block" style="border-radius: 1rem;">Sign in</button>
                  </div>
                </form>
                <div class="form-note-s2 pt-4"> New on our platform? <a href="javascript:void(0)" @click="set_page(2)"><span style="color:#1ee0ac;">Create an account</span></a>
                </div>
                <div class="text-center pt-4 pb-3">
                  <h6 class="overline-title overline-title-sap">
                    <span>OR</span>
                  </h6>
                </div>
                <ul class="nav justify-center gx-4">
                    <li class="nav-item">
                        <a :href="api_base_url+'google/auth/google'">
                          <button type="button" class="btn btn-outline-danger btn-block" style="border-radius: .6rem;"><i class="fab fa-google"></i>&nbsp;&nbsp; Sign in with Google</button>
                            </a>
                    </li>
                </ul>
              </div>
              <div class="nk-block nk-block-middle nk-auth-body" v-if="page_no==2">
                <div class="brand-logo pb-5">
                  <a href="#" class="logo-link">
                    <img class="logo-light logo-img logo-img-lg" :src="base_url+'images/logo-dark.png'" :srcset="base_url+'images/logo-dark.png'" alt="logo">
                    <img class="logo-dark logo-img logo-img-lg" :src="base_url+'images/logo-dark.png'" :srcset="base_url+'images/logo-dark.png'" alt="logo-dark">
                  </a>
                </div>
                <div class="nk-block-head">
                  <div class="nk-block-head-content">
                    <h5 class="nk-block-title">Sign-Up</h5>
                   
                  </div>
                </div>
                <form @submit.prevent="handleSubmit1"  class="form-validate is-alter" autocomplete="off" novalidate="novalidate">
                    <div class="form-group">
                    <div class="form-label-group">
                      <label class="form-label" for="email-address">Full Name</label>
                    </div>
                    <div class="form-control-wrap">
                      <input autocomplete="off" type="text" v-model="name1" class="form-control form-control-lg" required="" id="email-address" placeholder="Enter your email address">
                    </div>
                  </div>
                  <div class="form-group">
                    <div class="form-label-group">
                      <label class="form-label" for="email-address">Email Address</label>
                    </div>
                    <div class="form-control-wrap">
                      <input autocomplete="off" type="email" v-model="email1" class="form-control form-control-lg" required="" id="email-address" placeholder="Enter your email address">
                    </div>
                  </div>
                  <div class="form-group">
                    <div class="form-label-group">
                      <label class="form-label" for="password">Password</label>
                    </div>
                    <div class="form-control-wrap">
                      <a tabindex="-1" href="#" class="form-icon form-icon-right Password-switch lg" data-target="password">
                        <em v-if="viewPass==1" @click="set_pass(0)" class="Password-icon icon-show icon ni ni-eye"></em>
                        <em v-if="viewPass==0" @click="set_pass(1)" class="Password-icon icon-hide icon ni ni-eye-off"></em>
                      </a>
                      <input autocomplete="new-password" v-model="password1" :type="input_type" class="form-control form-control-lg" required="" id="password" placeholder="Enter your Password">
                    </div>
                  </div>
                  <div :class="'alert alert-' + msgType + ' mb-xl-0'" role="alert"
                                            v-if="msgTxt && msgTxt.length > 0">
                                            {{ msgTxt }}
                                        </div>
                                        <br>
                  <div class="form-group">
                    <button type="submit" class="btn btn-lg btn-success btn-block" style="border-radius: 1rem;">Sign Up</button>
                  </div>
                </form>
                <div class="form-note-s2 pt-4"> Already having account? <a href="javascript:void(0)" @click="set_page(1)"><span style="color:#1ee0ac;">Sign In</span></a>
                </div>
                <div class="text-center pt-4 pb-3">
                  <h6 class="overline-title overline-title-sap">
                    <span>OR</span>
                  </h6>
                </div>
                <ul class="nav justify-center gx-4">
                    <li class="nav-item">
                        <a :href="api_base_url+'google/auth/google'">
                          <button type="button" class="btn btn-outline-danger btn-block" style="border-radius: .6rem;"><i class="fab fa-google"></i>&nbsp;&nbsp; Sign in with Google</button>
                            </a>
                    </li>
                </ul>
              </div>
              <div class="nk-block nk-block-middle nk-auth-body" v-if="page_no==3">
                <div class="brand-logo pb-5">
                  <a href="#" class="logo-link">
                    <img class="logo-light logo-img logo-img-lg" :src="base_url+'images/logo-dark.png'" :srcset="base_url+'images/logo-dark.png'" alt="logo">
                    <img class="logo-dark logo-img logo-img-lg" :src="base_url+'images/logo-dark.png'" :srcset="base_url+'images/logo-dark.png'" alt="logo-dark">
                  </a>
                </div>
                <div class="nk-block-head">
                  <div class="nk-block-head-content">
                    <h5 class="nk-block-title">Forgot Password?</h5>
                   
                  </div>
                </div>
                <form @submit.prevent="handleSubmit2"  class="form-validate is-alter" autocomplete="off" novalidate="novalidate">
                   
                  <div class="form-group">
                    <div class="form-label-group">
                      <label class="form-label" for="email-address">Email Address</label>
                    </div>
                    <div class="form-control-wrap">
                      <input autocomplete="off" type="email" v-model="email2" class="form-control form-control-lg" required="" id="email-address" placeholder="Enter your email address">
                    </div>
                  </div>
                  <div :class="'alert alert-' + msgType + ' mb-xl-0'" role="alert"
                                            v-if="msgTxt && msgTxt.length > 0">
                                            {{ msgTxt }}
                                        </div>
                                        <br>
                  <div class="form-group">
                    <button type="submit" class="btn btn-lg btn-success btn-block" style="border-radius: 1rem;">Send</button>
                  </div>
                </form>
                <div class="form-note-s2 pt-4"> Remember Password? <a href="javascript:void(0)" @click="set_page(1)"><span style="color:#1ee0ac;">Sign In</span></a>
                </div>
                <div class="text-center pt-4 pb-3">
                  <h6 class="overline-title overline-title-sap">
                    <span>OR</span>
                  </h6>
                </div>
                <ul class="nav justify-center gx-4">
                    <li class="nav-item">
                        <a :href="api_base_url+'google/auth/google'">
                          <button type="button" class="btn btn-outline-danger btn-block" style="border-radius: .6rem;"><i class="fab fa-google"></i>&nbsp;&nbsp; Sign in with Google</button>
                            </a>
                    </li>
                </ul>
              </div>
            </div>
            <div class="nk-split-content nk-split-stretch bg-lighter d-flex toggle-break-lg toggle-slide toggle-slide-right toggle-screen-lg" data-toggle-body="true" data-content="athPromo" data-toggle-screen="lg" data-toggle-overlay="true">
              <div class="slider-wrap w-100 w-max-550px p-3 p-sm-5 m-auto">
                <div class="slider-init slick-initialized slick-slider slick-dotted" data-slick="{&quot;dots&quot;:true, &quot;arrows&quot;:false}">
                  <div class="slick-list draggable">
                    <div class="slick-track" style="opacity: 1; width: 3213px; transform: translate3d(-459px, 0px, 0px);">
                      <div class="slider-item slick-slide slick-cloned" data-slick-index="-1" id="" aria-hidden="true" style="width: 459px;" tabindex="-1">
                        <div class="nk-feature nk-feature-center">
                          <div class="nk-feature-img">
                            <img class="round" :src="base_url+'images/login_dash.png'" :srcset="base_url+'images/login_dash.png'" alt="">
                          </div>
                          <div class="nk-feature-content py-4 p-sm-5">
                            <h4>Your Smartest Meeting Assistant</h4>
                            <p>
                              Streamline your scheduling, automate follow-ups, and get AI-powered meeting 
                              summaries—all in one platform.
                            </p>
                          </div>
                        </div>
                      </div>
                      <div class="slider-item slick-slide slick-current slick-active" data-slick-index="0" aria-hidden="false" style="width: 459px;" tabindex="0" role="tabpanel" id="slick-slide00" aria-describedby="slick-slide-control00">
                        <div class="nk-feature nk-feature-center">
                          <div class="nk-feature-img">
                            <img class="round" :src="base_url+'images/login_dash.png'" :srcset="base_url+'images/login_dash.png'" alt="">
                          </div>
                          <div class="nk-feature-content py-4 p-sm-5">
                            <h4>Your Smartest Meeting Assistant</h4>
                            <p>
                              Streamline your scheduling, automate follow-ups, and get AI-powered meeting summaries—all in 
                              one platform.
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="slider-dots"></div>
                <div class="slider-arrows"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </template>
  <script>
    import {
      mainBaseUrl,apiBaseUrl
    } from '@/apis/appconst';
    import { frogotUser, loginUser, regUser } from '@/apis/webapis';

    export default {
      name: 'AppLogin',
      methods: {
        set_page($pno){
            this.page_no = $pno
        },
        set_pass($pno){
            this.viewPass = $pno
            if(this.viewPass==1) {
                this.input_type = "text";
            }
            else{
                this.input_type = "password";
            }
        },
        valField1(field, msg) {
            if (field.length > 0) {
                return true;
            } else {
                this.msgType = "danger";
                this.msgTxt = msg;
                return false;
            }
        },
        async handleSubmit() {
            if (this.valField1(this.email, 'Enter Email Address') &&
                this.valField1(this.password, 'Enter Password')
            ) {
                this.msgType = "";
                this.msgTxt = "";
               
                const response = await loginUser(this.email,this.password);
                if (response.status) {
                    sessionStorage.setItem('ldata', JSON.stringify(response.user));
                    this.msgType = "success";
                    this.msgTxt = 'Sign-in successful!';
                    window.location.href = "/";
                } else {
                    this.msgType = "danger";
                    this.msgTxt = response.message;
                }
            }
        },
        async handleSubmit1() {
            if (this.valField1(this.name1, 'Enter Email Address') &&
                this.valField1(this.email1, 'Enter Email Address') &&
                this.valField1(this.password1, 'Enter Password')
            ) {
                this.msgType = "";
                this.msgTxt = "";
               
                const response = await regUser(this.name1,this.email1,this.password1);
                if (response.status) {
                    this.msgType = "success";
                    this.msgTxt = response.message;
                    this.set_page(1);
                } else {
                    this.msgType = "danger";
                    this.msgTxt = response.message;
                }
            }
        },
        async handleSubmit2() {
            if (this.valField1(this.email2, 'Enter Email Address')) {
                this.msgType = "";
                this.msgTxt = "";
               
                const response = await frogotUser(this.email2);
                if (response.status) {
                    this.msgType = "success";
                    this.msgTxt = response.message;
                    this.set_page(1);
                } else {
                    this.msgType = "danger";
                    this.msgTxt = response.message;
                }
            }
        }
      },
      data() {
        return {
          base_url: "",
          api_base_url:apiBaseUrl,
          l1: ["1", "2", "3", "4", "5"],
          page_no:1,
          viewPass:0,
          email:"",
          password:"",
          name1:"",
          email1:"",
          email2:"",
          password1:"",
          input_type:"password",
          msgType : "",
          msgTxt : ""
        };
      },
      mounted() {
        this.base_url = mainBaseUrl;
        if((window.location.href+"").includes("udata")){
          var udata = this.$route.query.udata;
          var ldata = atob(udata); 
          if(ldata.length>0){
            sessionStorage.setItem("ldata",ldata);
            window.location.href="/";
          }
        }
      },
    }
  </script>